import { useNavigate } from 'react-router-dom';
import { Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import errorImg from '../../assets/images/error.jpg';
import { CenteredImageForm } from '../../layouts';

import { DynamicIcon } from './';

/**
 * Fallback component for ErrorBoundary
 * @returns
 */
const Fallback = ({ error, resetErrorBoundary }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <CenteredImageForm img={errorImg} bg={true}>
      <Typography variant="h6" sx={{ mb: 5 }} color={'error'}>
        <DynamicIcon
          iconName={'ErrorOutline'}
          color={'error'}
          sx={{ verticalAlign: 'middle' }}
        />{' '}
        Ooops! Something went wrong :({' '}
      </Typography>

      <Typography variant="body" color={'error'}>
        {error.message}
      </Typography>

      <Button
        variant="contained"
        onClick={() => {
          resetErrorBoundary();
          navigate('/aktivu/dashboard');
        }}
        sx={{ mt: 10, backgroundColor: theme.palette.error.main }}
        startIcon={<DynamicIcon iconName={'Dashboard'} />}
      >
        Go To Dashboard
      </Button>
    </CenteredImageForm>
  );
};

export default Fallback;
